import Vue from "vue";
import axios from "axios";

class NetworkService {
  static uri(path) {
    //call api from env
    return process.env.VUE_APP_API_URL + path;
  }

  static async request(endpoint, params) {
    let headers = !NetworkService.getToken()
      ? NetworkService.headers()
      : NetworkService.headerWithToken();

    // let fullurl = NetworkService.uri() + endpoint;
    let options = Object.assign(
      {},
      {
        url: endpoint,
        headers,
      },
      params
    );

    return await axios(endpoint, options).then(NetworkService.handleResponse);
    // .catch(NetworkService.handleError);
  }

  //init request with token
  static headerWithToken() {
    return Object.assign(NetworkService.headers(), {
      Authorization: "Bearer " + NetworkService.getToken(),
    });
  }

  static headers() {
    return {
      "content-type": "application/json",
      accept: "application/json",
    };
  }

  static post(endpoint, payload, options) {
    if (options == null) {
      options = Object.assign({}, options, {
        data: JSON.stringify(payload),
        method: "POST",
      });
    } else {
      options.method = "POST";
      options.data = payload;
    }
    // options = Object.assign({}, options, {
    //     data: JSON.stringify(payload),
    //     method: 'POST'
    // })

    return NetworkService.request(NetworkService.uri(endpoint), options);
  }

  static get(endpoint, options) {
    options = Object.assign({}, options, {
      method: "GET",
      data: null,
    });
    return NetworkService.request(NetworkService.uri(endpoint), options);
  }

  static delete(endpoint, options) {
    options = Object.assign({}, options, {
      method: "DELETE",
    });
    return NetworkService.request(NetworkService.uri(endpoint), options);
  }

  static put(endpoint, payload, options) {
    if (options == null) {
      options = Object.assign({}, options, {
        data: JSON.stringify(payload),
        method: "PUT",
      });
    } else {
      options.method = "PUT";
      options.data = payload;
    }
    return NetworkService.request(NetworkService.uri(endpoint), options);
  }

  static handleResponse(res) {
    const { status, data } = res;

    return status >= 200 && status <= 300 ? data : null;
  }

  static handleError(error) {
    const errs = error && error.response ? error.response.data : error;
    console.warn("[ERROR]", errs);
    return errs;
  }

  static getToken() {
    //temp method .  need get from vuex
    // if (sessionStorage.getItem("remember") == "rememberme") {
    //   return localStorage.getItem("token");
    // } else if (sessionStorage.getItem("remember") == "notrememberme") {
    //   return sessionStorage.getItem("token");
    // }
    return $cookies.get("token");
  }
}

export default NetworkService;
